// controls/separator.js — séparateur statique avec marges configurables
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";
import { BiMinus } from "react-icons/bi";

/**
 * Création du champ statique "Séparateur"
 */
export function createSeparatorField() {
  return {
    type: "null",
    title: "Séparateur",
    "x-ui": "separator",
    "x-static": true,
    "x-style": {
      spaceBefore: 16,
      spaceAfter: 16,
      color: "#999",
      width: "100%",
      thickness: 1,
    },
  };
}

/**
 * Éditeur du champ séparateur
 */
export function EditSeparatorField({ field, onChange }) {
  const [spaceBefore, setSpaceBefore] = useState(
    field["x-style"]?.spaceBefore ?? 16
  );
  const [spaceAfter, setSpaceAfter] = useState(
    field["x-style"]?.spaceAfter ?? 16
  );
  const [color, setColor] = useState(field["x-style"]?.color || "#999");
  const [width, setWidth] = useState(field["x-style"]?.width || "100%");
  const [thickness, setThickness] = useState(
    field["x-style"]?.thickness ?? 1
  );

  // 🔄 synchro vers le parent
  useEffect(() => {
    const updated = {
      ...field,
      "x-style": { spaceBefore, spaceAfter, color, width, thickness },
    };
    onChange(updated);
  }, [spaceBefore, spaceAfter, color, width, thickness]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      <div className="mb-3">
        <label className="form-label fw-bold d-flex align-items-center gap-2">
          <BiMinus size={18} /> Configuration du séparateur
        </label>

        <div className="row g-3 align-items-end">
          <div className="col-6 col-md-3">
            <label className="form-label">Espace avant (px)</label>
            <input
              type="number"
              className="form-control form-control-sm"
              min="0"
              value={spaceBefore}
              onChange={(e) => setSpaceBefore(Number(e.target.value))}
            />
          </div>

          <div className="col-6 col-md-3">
            <label className="form-label">Espace après (px)</label>
            <input
              type="number"
              className="form-control form-control-sm"
              min="0"
              value={spaceAfter}
              onChange={(e) => setSpaceAfter(Number(e.target.value))}
            />
          </div>

          <div className="col-6 col-md-3">
            <label className="form-label">Épaisseur (px)</label>
            <input
              type="number"
              className="form-control form-control-sm"
              min="1"
              max="10"
              value={thickness}
              onChange={(e) => setThickness(Number(e.target.value))}
            />
          </div>

          <div className="col-6 col-md-3">
            <label className="form-label">Couleur</label>
            <input
              type="color"
              className="form-control form-control-sm form-control-color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
        </div>

        <div className="mt-3 border rounded bg-light p-3 text-center">
          <div
            style={{
              marginTop: spaceBefore,
              marginBottom: spaceAfter,
              borderBottom: `${thickness}px solid ${color}`,
              width: width,
              marginInline: "auto",
            }}
          ></div>
          <small className="text-muted">Aperçu du séparateur</small>
        </div>
      </div>
    </>
  );
}

export const editSeparatorField = (props) => <EditSeparatorField {...props} />;

/* =========================================================
   🧩 FRONT — rendu du bloc statique Séparateur
   ========================================================= */
export const RenderSeparatorField = ({ field }) => {
  const style = field["x-style"] || {};
  const {
    spaceBefore = 16,
    spaceAfter = 16,
    color = "#999",
    width = "100%",
    thickness = 1,
  } = style;

  return (
    <div
      className={`fb-field fb-static-separator ${field["x-bloc-class"] || "mb-3"}`}
      style={{
        marginTop: spaceBefore,
        marginBottom: spaceAfter,
      }}
    >
      <div
        className={field["x-control-class"] || ""}
        style={{
          borderBottom: `${thickness}px solid ${color}`,
          width: width,
          marginInline: "auto",
        }}
      ></div>
    </div>
  );
};
